<!-- 产业服务--物流供应详情-->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <div class="info-detail-title">
          <div class="title-img">
              <div class="title-img-show" v-bind:style="{backgroundImage:'url('+infoPage.detail.images[currentImgIndex]+')'}"></div>
              <ul class="title-img-ul">
                <li v-for="(info,index) in infoPage.detail.images" v-if="index<5" :key="index" v-bind:class="{'active': index==currentImgIndex}" v-on:click="currentImgIndex = index" @mouseover="currentImgIndex = index">
                  <img :src="info" height="60px"/>
                </li>
              </ul>
          </div>
          <div class="title-info">
            <div class="title-1">{{infoPage.detail.name}}</div>
            <div class="label-1">{{infoPage.detail.desc}}</div>
            <table class="title-detail-table" cellspacing="0px" border="0px">
              <tr>
                <td class="td-title">价格：</td><td class="td-price" colspan="2">{{infoPage.detail.price}}</td>
              </tr>
              <tr>
                <td class="td-title">物流方式：</td><td class="td-value" colspan="2">{{infoPage.detail.transport_price}}</td>
              </tr>
              <!--<tr>
                <td class="td-title">所在地：</td><td class="td-value" colspan="2">{{detail.info.address}}</td>
              </tr>-->
              <tr>
                <td class="td-title">发布日期：</td><td class="td-value">{{infoPage.detail.create_time}}</td>
              </tr>
              <tr>
                <td class="td-title">所属分类：</td><td class="td-act">{{infoPage.detail.category_name}}</td>
                <td rowspan="2">
                  <a href="#" class="collection">收藏</a>
                  <a href="#" class="share">分享</a>
                </td>
              </tr>
            </table>
            <table class="title-link-table" style="display:none">
              <tr>
                <td>联系方式</td>
                <td rowspan="2" width="120px">
                  <a href="#" class="link-view">点击查看</a>
                </td>
              </tr>
              <tr>
                <td class="td-value phone" colspan="2">{{detail.user.phone}}(登录后可查看完整号码)</td>
              </tr>
              <tr>
                <td class="td-value qq" colspan="2">(登录后可查看完整号码)</td>
              </tr>
              <tr>
                <td class="td-value weixing" colspan="2">(登录后可查看完整号码)</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="info-list-content">
            <div class="list-content-msg">温馨提示：本平台是公开发布平台，供求交易时请注意甄别信息的真伪，交易风险请自行把控。</div>
            <div class="list-content-detail">
                <div class="detail-label">
                  详细信息
                </div>
                <div class="info-detail-content">
                  <p  v-html="infoPage.detail.content"></p>
                </div>
            </div>
          </div>
      </div>
      <div class="content-col col-per-30">
        <infoContent :showTitle="false" :showMore="false" :infoBlock="infoBlock1" :info="detail.user" title="" label="INFORMARION"/>
        <infoContentList :showTitle="true" :showMore="false" :infoBlock="infoBlock2" :infoList="detail.others" title="该店铺其他供货" label="" count="8"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoContentList from '../block/InfoContentList'
import InfoContent from '../block/InfoContent'
import InfoBlock13 from '../block/InfoBlock13'
import InfoBlock14 from '../block/InfoBlock14'

export default {
  name: 'Cyfw04Detail',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: String,
      default: '16'
    },
    label: {
      type: String,
      default: ''
    },
    count: {
      type: String,
      default: '5'
    }
  },
  components: {
    'infoContentList': InfoContentList,
    'infoContent':InfoContent,
  },
  data() {
    return {
      imgRootPath:this.Global.resourceDomain,
      currentImgIndex:0,
      msg: '',
      infoBlock1:InfoBlock13,
      infoBlock2:InfoBlock14,
      detail:{info:{banner:[]},user:{phone:13759439725}},
      infoPage:{detail:{},recommend_list:[]},
      type:1,
    }
  },
  methods:{
    detail_Req(detailId,type){
      let that=this;
      let params={id:detailId,type:type};
      that.$dataApi.meansDetail(params).then(res =>{
          that.msg=res.msg;
          that.infoPage=res.data;

        });
    },
  },
  created:function(){
    let that=this;
    let detailId=that.$route.params.id;
    this.type=that.$route.params.type;
    //this.newsDetail=this.Global.newsDetail;
    console.log("当前导航页："+this.Global.siteDefaultNav);
    //this.newsDetail=this.Global.newsDetail;
    //this.infoList=this.Global.imgInfoList2.slice(0,this.count);
    console.log("当前导航页：detailId="+detailId+"--type="+this.type);
    that.detail_Req(detailId,this.type);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}


.info-detail-title{
  position:relative;
  width:100%;
  height:420px;
  background:#fff;
  padding:30px 0px 10px 0px;
  margin-top:-20px;
  margin-bottom:0px;
  border-bottom:0px;
  text-align:left;
}
.info-detail-title .title-img{
  float:left;
  width: 300px;
  height:300px;
  text-align:left;
  //background:red;
}

.info-detail-title .title-img-show{
  text-align:center;
  width: 300px;
  height:300px;
  border:1px solid #ddd;
  background:#eee;
  background-size: 300px auto;
  background-repeat: no-repeat;
  background-position: center center;
}

.title-img-ul {
  display:flex;
  justify-content:flex-start;
  list-style-type: none;
  //margin: 5px 0px 0px 0px;
  width:100%;
  height:40px;
  text-align:center;
  list-style-type: none;
  padding: 5px 0px 0px 0px;
}

.title-img-ul li {
  float:left;
  margin: 0px 2px 0px 0px;
  padding:0px;
  height:100%;
  text-align:left;
  //background:red;
}

.title-img-ul li img{
  width: 58px;
  height:50px;
  border:1px solid #fff;
}

.title-img-ul li img:hover{
  cursor: pointer;
  border:1px solid var(--color6);
}


.title-img-ul li .active{
  border:1px solid var(--color6);
}


.info-detail-title .title-info{
  float:left;
  width: calc(100% - 300px);
  height:50px;
  text-align:left;
  //background:red;
}

.info-detail-title .title-1{
  padding:0px 0px 0px 20px;
  height:50px;
  font-size:16px;
  font-weight:800;
  line-height:30px;
  text-align:left;
  //background:green;
}

 .title-1 span{
   padding:3px 5px 3px 5px;
   margin-right:10px;
   font-size:14px;
   color:#fff;
   font-weight:100;
   line-height:30px;
   text-align:left;
   background:var(--color6);
   border-radius:5px;
 }

 .info-detail-title .label-1{
   padding:10px 0px 10px 20px;
   color:#888;
   font-size:14px;
   line-height:25px;
   text-align:left;
 }

.info-detail-title .title-act{
  float:left;
  width:200px;
  height:80px;
  text-align:center;
  line-height:80px;
}

.title-detail-table{
  width:100%;
  padding-left:20px;
  font-size:12px;
  line-height:30px;
  color:#888;

}

.title-detail-table .td-title{
  width:70px;
}

.title-detail-table tr:last-child td{
  border-bottom:1px solid #bbb;
}

.title-detail-table .td-value{
  //padding-left:20px;
  //color: var(--color6);
}

.title-detail-table .td-price{
  font-size:14px;
  font-weight:600;
  color: var(--color6);
}

.title-link-table{
  width:100%;
  padding-left:20px;
  font-size:12px;
  line-height:30px;
  color:#888;
}

.title-link-table td{
  line-height:30px;
}

.list-content-msg{
  position:relative;
  width:100%;
  padding:0px;
  text-align:left;
  font-size:14px;
  color: var(--color6);
}

.list-content-detail{
  position:relative;
  width:100%;
  padding:0px;
  margin-top:10px;
  margin-bottom:20px;
  border-top:2px solid #000;
  border-left:1px solid #eee;
  border-right:1px solid #eee;
  border-bottom:1px solid #eee;
}

.list-content-detail .detail-label{
  padding:0px 0px 0px 2px;
  height:40px;
  font-size:14px;
  font-weight:600;
  line-height:40px;
  text-align:left;
  border-bottom:1px solid #eee;
}

.link-view{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  border:1px solid var(--color7);
  color:#000;
  line-height:20px;
  text-align:center;
}

.link-view:hover{
  background:var(--color7);
  color:#fff;
}

.phone{
  padding-left:30px;
  background-image:url(./../../assets/phone.png);
  background-size: 18px 18px;
  background-repeat: no-repeat;
  background-position: 0px 6px;
}

.qq{
  padding-left:30px;
  background-image:url(./../../assets/qq.png);
  background-size: 16px 16px;
  background-repeat: no-repeat;
  background-position: 0px 6px;
}

.weixing{
  padding-left:30px;
  background-image:url(./../../assets/weixing.png);
  background-size: 18px 18px;
  background-repeat: no-repeat;
  background-position: 0px 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Cyfw01DetailC.vue